import { Injectable, OnDestroy, computed, signal } from '@angular/core';
import { BehaviorSubject, Observable, filter, map } from 'rxjs';

import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService extends DataService<string[]> implements OnDestroy {
  private readonly systemAdminSignal = signal(false);

  readonly isSystemAdmin = computed(() => this.systemAdminSignal());

  isAdmin: boolean = false;
  isAgent: boolean = false;
  isGroupAdmin: boolean = false;
  isTrainer: boolean = false;

  private loadedSubject = new BehaviorSubject<boolean>(false);
  loaded$: Observable<void> = this.loadedSubject.asObservable().pipe(
    filter(Boolean),
    map(() => void 0)
  );

  override async set(val: string[] | undefined, isAdmin?: boolean) {
    await super.set(val);
    this.value$.next(val);
    const roles = val ?? [];

    this.isAdmin = !!isAdmin;
    this.systemAdminSignal.set(this.isAdmin);
    this.isAgent = roles.includes('agent');
    this.isGroupAdmin = roles.includes('group-admin');
    this.isTrainer = roles.includes('trainer');

    this.loadedSubject.next(true);
  }

  public override reset() {
    super.reset();
    this.isAdmin = false;
    this.systemAdminSignal.set(false);
    this.isAgent = false;
    this.isGroupAdmin = false;
    this.isTrainer = false;
    this.loadedSubject.next(false);
  }
}
